import { render, staticRenderFns } from "./VolumeRulesManagement.vue?vue&type=template&id=aa01bf62&scoped=true"
import script from "./VolumeRulesManagement.vue?vue&type=script&lang=js"
export * from "./VolumeRulesManagement.vue?vue&type=script&lang=js"
import style0 from "./VolumeRulesManagement.vue?vue&type=style&index=0&id=aa01bf62&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa01bf62",
  null
  
)

export default component.exports